import script from "./SmsRequestsList.vue?vue&type=script&setup=true&lang=js"
export * from "./SmsRequestsList.vue?vue&type=script&setup=true&lang=js"

import "./SmsRequestsList.vue?vue&type=style&index=0&id=871287e0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-871287e0"]])

export default __exports__